import { z } from "zod";

import { i18n } from "@lib/i18n";
import { queries } from "@lib/queries";
import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";

const planningSearchSchema = z
    .object({
        week: z.number(),
        year: z.number(),
    })
    .partial();
type PlanningSearch = z.infer<typeof planningSearchSchema>;
export const planningRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `planning`,
    validateSearch: (search: PlanningSearch) => planningSearchSchema.parse(search),
    component: lazyRouteComponent(() => import("./index")),
    beforeLoad: () => {
        requireScope("account");
        return { getTitle: () => i18n.doc_title_planning() };
    },
});

export const planningEditionRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `planning/$taskId`,
    component: lazyRouteComponent(
        () => import("./PlanningEdition/PlanningEdition"),
        "PlanningEdition",
    ),
    loader: async ({ context, params }) => {
        const task = await context.queryClient.fetchQuery(queries.task.detail(params.taskId));
        if (!task || !task.shifts || task.shifts.length === 0 || task.flexiblePlanning) {
            throw redirect({ to: `/planning` });
        }
    },
    beforeLoad: () => {
        requireScope("account");
        return { getTitle: () => i18n.doc_title_planning() + " - Edition" };
    },
});
